import {
  SPOKEN_PICK_SHAPES,
  type SpokenPickShape,
} from '@/shared-responder-v2-core';

export const SPOKEN_PICK_DEBOUNCE_MS = 1000;

export const SPOKEN_PICK_EXTRACTION_TIMEOUT_MS = 4000;

export const SPOKEN_PICK_CACHE_LIMIT = 50;

export const SPOKEN_PICK_QUESTION_TYPES = {
  [SPOKEN_PICK_SHAPES.Choice]: 'MultipleChoice',
  [SPOKEN_PICK_SHAPES.Rating]: 'Rating',
  [SPOKEN_PICK_SHAPES.Ranking]: 'Ranking',
} as const satisfies Record<SpokenPickShape, string>;
